var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.924,
    height: 19.924,
    viewBox: "0 0 19.924 19.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12243",
    "data-name": "Group 12243",
    transform: "translate(-1308.076 -1155.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload",
    "data-name": "Icon feather-upload",
    transform: "translate(1309.076 1156.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M4.5,22.5v3.983a1.992,1.992,0,0,0,1.992,1.992H20.432a1.992,1.992,0,0,0,1.992-1.992V22.5",
    transform: "translate(-4.5 -10.551)",
    fill: "none",
    stroke: "#b98772",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M10.5,9.479,15.479,4.5l4.979,4.979",
    transform: "translate(-6.517 -4.5)",
    fill: "none",
    stroke: "#b98772",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M18,4.5V16.449",
    transform: "translate(-9.038 -4.5)",
    fill: "none",
    stroke: "#b98772",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dae1f88551f1ca661e59c9bca5468bca.svg";
export { ForwardRef as ReactComponent };